import { RegistrationStatus } from 'libs/utils/src/lib/player-portals/constants/pp-registration-constants';

export const checkIfShowAcceptPoliciesBtn = (
  participant: any,
  isPlayersDataSource: boolean,
) => {
  if (isPlayersDataSource) {
    return (
      participant?.registrationStatus === '1' &&
      (participant?.antiDopingPolicyAcceptance === false ||
        participant?.antiBettingPolicyAcceptance === false)
    );
  }
  return participant?.antiCorruptionAndBettingPolicyAcceptance === false;
};

export const checkIfShowCompleteRegistrationBtn = (
  participant: any,
  isPlayersDataSource: boolean,
) => {
  if (isPlayersDataSource) {
    return (
      participant?.registrationStatus === '1' &&
      participant?.antiDopingPolicyAcceptance === true &&
      participant?.antiBettingPolicyAcceptance === true &&
      participant?.playerAddressLine1 &&
      participant?.playerPostcodeOrZipCode
    );
  }
  return (
    participant?.registrationStatus !== RegistrationStatus.Registered &&
    participant?.antiCorruptionAndBettingPolicyAcceptance === true
  );
};
